import React from "react";
import styled from "styled-components";

const MoleculeSizeModeArea = ({
  width = "1920",
  height = "1080",
  initialMode = "web",                // 'web' | 'kiosk'
  onModeChange,                       // (mode) => void
}) => {
  const [mode, setMode] = React.useState(initialMode);

  const selectMode = (next) => {
    setMode(next);
    onModeChange && onModeChange(next);
  };

  return (
    <StyledContainer>
    {/* 오른쪽: 모드 토글 */}
        <Segmented role="tablist" aria-label="디스플레이 모드">
        <SegmentButton
          type="button"
          role="tab"
          aria-selected={mode === "web"}
          data-active={mode === "web"}
          onClick={() => selectMode("web")}
        >
          웹형(PC/브라우저)
        </SegmentButton>
        <SegmentButton
          type="button"
          role="tab"
          aria-selected={mode === "kiosk"}
          data-active={mode === "kiosk"}
          onClick={() => selectMode("kiosk")}
        >
          키오스크형(세로)
        </SegmentButton>
      </Segmented>


      {/* 왼쪽: 타이틀 + 해상도 */}
      <LeftGroup>
        <StyledSizeGroup>
          <StyledSizeBox>
            <StyledSizeNumber>{width}</StyledSizeNumber>
          </StyledSizeBox>
          <StyledMultiplySymbol>x</StyledMultiplySymbol>
          <StyledSizeBox>
            <StyledSizeNumber>{height}</StyledSizeNumber>
          </StyledSizeBox>
          <StyledUnit>px</StyledUnit>
        </StyledSizeGroup>
      </LeftGroup>

    </StyledContainer>
  );
};

export default MoleculeSizeModeArea;

/* ---------------- styled ---------------- */

const StyledContainer = styled.div`
  width: 100%;
  padding: 12px 16px;
  background: #ecf2fe;
  border-top: 1px solid #9ebdfa;
  border-bottom: 1px solid #9ebdfa;
  display: flex;
  justify-content: space-between; /* 왼쪽 정보 / 오른쪽 토글 */
  align-items: center;
  gap: 16px;
  justify-content: center;
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StyledTitle = styled.span`
  color: black;
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  line-height: 24px;
`;

const StyledSizeGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
`;

const StyledSizeBox = styled.div`
  padding: 0 8px;
  background: none;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

const StyledSizeNumber = styled.span`
  color: black;
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

const StyledMultiplySymbol = styled.span`
  color: black;
  font-size: 14px;
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  line-height: 21px;
`;

const StyledUnit = styled.span`
  color: black;
  font-size: 14px;
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  line-height: 21px;
`;

/* ---- 토글 디자인 (요청하신 스타일 반영) ---- */
const Segmented = styled.div`
  padding: 4px;
  background: #ffffff;
  border-radius: 22.4px;
  display: inline-flex;
  align-items: center;
  gap: 0;
`;

const SegmentButton = styled.button`
  height: 32px;
  padding: 16px 16px;
  background: transparent;
  border: 0;
  border-radius: 19.2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Pretendard", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  color: #a3a3a3;
  cursor: pointer;
  transition: background 140ms ease, color 140ms ease;

  &[data-active="true"] {
    background: #ecf2fe; /* 선택된 탭의 파란 하이라이트 */
    color: #256ef4;
  }

  &:focus-visible {
    outline: 2px solid #256ef4;
    outline-offset: 2px;
    border-radius: 20px;
  }
`;
